<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <strong>创建</strong> 管理员
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="姓名" label-for="name">
          <b-form-input id="name" type="text" v-model.trim="data.name" required />
        </b-form-group>
        <b-form-group label="Email" label-for="email">
          <b-form-input id="email" type="text" v-model.trim="data.email" required />
        </b-form-group>
        <b-form-group label="部门" label-for="remark">
          <b-form-input id="remark" type="text" v-model.trim="data.remark" required />
        </b-form-group>
        <b-form-group label="手机号" label-for="mobile">
          <b-form-input id="mobile" type="number" v-model.trim="data.mobile" required />
        </b-form-group>
        <b-form-group label="类型" label-for="admin_type">
          <b-form-select id="admin_type" v-model="data.admin_type" :options="admin_types" />
        </b-form-group>
        <b-form-group label="点赞中心权限" label-for="vote_auth">
          <b-form-radio-group
            id="vote_auth"
            v-model="data.vote"
            :options="vote_options"
            name="radio-options" />
        </b-form-group>
        <b-form-group label="点赞中心权限（海外版）" label-for="edition_auth">
          <b-form-radio-group
            id="edition_auth"
            v-model="data.edition"
            :options="edition_options"
            name="edition-radio-options" />
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check" /> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-danger"><i class="fa fa-repeat" /> 复位</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'

export default {
  name: 'admin-create',
  mixins: [Error],
  data () {
    return {
      data: {
        name: '',
        email: '',
        remark: '',
        mobile: '',
        admin_type: null,
        vote: false,
        edition: false
      },
      admin_types: consts.ADMIN_TYPES,
      vote_options: consts.VOTE_RADIO_JUDGE_OPTIONS,
      edition_options: consts.VOTE_RADIO_JUDGE_OPTIONS
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      if (!this.data.vote) {
        this.data.vote = false
      }
      if (!(/^1[3456789]\d{9}$/.test(this.data.mobile))) {
        this.$message.error('手机号码有误，请重填')
      } else {
        api.createData(this, api.getAdminCreate(), this.data, 'admin-list')
      }
    },
    onReset (evt) {
      this.data = {
        name: '',
        email: '',
        remark: '',
        mobile: '',
        admin_type: '管理员类型',
        vote: false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AdminCreate.vue?ac44aec6